export { OxfordShieldIcon } from './oxford-shield'
